import {
  LeadExperiment,
  LeadModel,
  PreApplicationStep,
  RoutingDirection,
} from '~/src/models/leads/LeadModel'

import { SalesDemoForm } from '~/src/routes/UserQualification/pages/sales-demo-type'

export const preApplicationSteps = [null, ...Object.values(PreApplicationStep)]

export function buildSignUpQueryParams(
  values: SalesDemoForm,
  lead: LeadModel | null,
  currency?: 'GBP'
): string {
  const params = new URLSearchParams()

  if (values.first_name) {
    params.append('first_name', values.first_name)
  }

  if (values.last_name) {
    params.append('last_name', values.last_name)
  }

  if (lead?.company_email) {
    params.append('email', lead.company_email)
  }

  if (values.interested_in_products.length > 0) {
    params.append('interested_in_products', values.interested_in_products.join(','))
  }

  if (currency) {
    params.append('currency', currency)
  }

  return params.toString()
}

export const getPreApplicationRouteName = (step: PreApplicationStep | null) => {
  switch (step) {
    case null:
      return 'company-size'
    case PreApplicationStep.COMPANY_SIZE:
      return 'company-size'
    case PreApplicationStep.MONTHLY_SPEND:
      return 'monthly-spend'
    case PreApplicationStep.UNQUALIFIED:
      return 'demo-only'
    case PreApplicationStep.SALES_QUALIFIED:
      return 'contact-sales'
    case PreApplicationStep.INTERESTED_PRODUCTS:
      return 'interested-products'
    // This is in web
    case PreApplicationStep.DEMO_REQUESTED:
      return 'demo-requested'
    // This is in web
    case PreApplicationStep.SELF_SERVICE_QUALIFIED:
      return 'self-service'
  }
}

export const comparePreApplicationSteps = (
  step1: PreApplicationStep | null,
  step2: PreApplicationStep | null
) => preApplicationSteps.indexOf(step1) - preApplicationSteps.indexOf(step2)

export const getCurrentStep = (overriding_to_sales: boolean, lead: LeadModel | null) => {
  const shouldSkipPrequal = Boolean(lead?.skipped_prequal)

  if (overriding_to_sales) {
    return PreApplicationStep.SALES_QUALIFIED
  }

  if (!lead) {
    return PreApplicationStep.COMPANY_SIZE
  }

  // When the endpoint-scan obfuscation flag is on, the backend attaches the
  // EnablePrequalBypass experiment label. Skip straight to self-service sign-up
  // so the user doesn't get stuck in a hung prequal state.
  if (lead.experiments?.includes(LeadExperiment.EnablePrequalBypass)) {
    return PreApplicationStep.SELF_SERVICE_QUALIFIED
  }

  const interested_in_nothing =
    !lead.interested_in_bill_payments &&
    !lead.interested_in_corporate_cards &&
    !lead.interested_in_reimbursements &&
    !lead.interested_in_flex &&
    !lead.interested_in_procurement &&
    !lead.interested_in_accounts_receivable &&
    !lead.interested_in_stack &&
    !lead.interested_in_token_spend_management

  if (!shouldSkipPrequal) {
    if (!lead.has_employee_count) {
      return PreApplicationStep.COMPANY_SIZE
    }

    if (!lead.has_estimated_monthly_spend) {
      return PreApplicationStep.MONTHLY_SPEND
    }

    if (lead.routing_direction === RoutingDirection.UNQUALIFIED) {
      return PreApplicationStep.UNQUALIFIED
    }

    if (interested_in_nothing) {
      return PreApplicationStep.SELF_SERVICE_QUALIFIED
    }
  }

  if (lead.requested_demo) {
    return PreApplicationStep.DEMO_REQUESTED
  }

  if (lead?.sales_meeting_eligible) {
    return PreApplicationStep.SALES_QUALIFIED
  }

  return PreApplicationStep.SELF_SERVICE_QUALIFIED
}
